import React from "react";
import { Reveal } from "../components/Reveal";
import { PageHero, CtaBand, SectionHead } from "../components/UI";
import { IconBolt, IconShield, IconUsers, IconCheck, IconText } from "../components/Icons";

export function About() {
  return (
    <>
      <PageHero
        eyebrow="Giới thiệu"
        title="Chúng tôi tin cuộc họp nên kết thúc bằng hành động, không phải bằng một file ghi âm bị quên lãng"
        sub="Ghi Âm Pro ra đời để xoá bỏ khoảng cách giữa những điều được nói trong phòng họp và những việc thực sự được làm sau đó."
      />

      <section className="section">
        <div className="container split">
          <Reveal>
            <span className="eyebrow">Sứ mệnh</span>
            <h2>Biến mỗi cuộc họp thành dữ liệu có cấu trúc và việc làm cụ thể</h2>
            <p>
              Trong môi trường hành chính và doanh nghiệp, phần lớn quyết định quan trọng diễn ra
              trong các cuộc họp. Nhưng việc ghi chép thủ công khiến thông tin dễ thất lạc, biên
              bản chậm trễ và nhiệm vụ không được theo dõi đến nơi đến chốn.
            </p>
            <p style={{ marginTop: 14 }}>
              Ghi Âm Pro tự động hoá toàn bộ chuỗi công việc đó — từ ghi âm, phiên âm, phân tích
              đến biên bản và nhiệm vụ — để con người tập trung vào việc ra quyết định và thực thi.
            </p>
          </Reveal>
          <Reveal delay={120} className="visual">
            <div style={{ display: "grid", gap: 12 }}>
              {[
                ["Nghe lại & gõ tay", "Hàng giờ sau mỗi cuộc họp"],
                ["Ghi Âm Pro", "Dự thảo biên bản trong ít phút"],
              ].map(([h, p], i) => (
                <div
                  key={i}
                  className="mock-row"
                  style={{
                    alignItems: "center",
                    borderColor: i === 1 ? "var(--brand)" : "var(--line-2)",
                  }}
                >
                  <div className="avatar" style={{ background: i === 1 ? "#3b4ef0" : "#9aa6c8" }}>
                    {i === 1 ? <IconBolt size={18} /> : <IconText size={18} />}
                  </div>
                  <div>
                    <div className="who">{h}</div>
                    <div className="tx">{p}</div>
                  </div>
                  {i === 1 && (
                    <span className="badge b2" style={{ marginLeft: "auto" }}>
                      Nhanh hơn
                    </span>
                  )}
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <section className="section soft">
        <div className="container">
          <SectionHead center eyebrow="Giá trị cốt lõi" title="Những nguyên tắc định hình sản phẩm" />
          <div className="grid cards-3">
            {[
              [<IconText size={24} />, "", "Chính xác là trên hết", "Một biên bản chỉ hữu ích khi đáng tin. Chúng tôi tối ưu độ chính xác cho tiếng Việt và cho phép con người rà soát."],
              [<IconShield size={24} />, "teal", "Tôn trọng dữ liệu", "Nội dung họp là tài sản của tổ chức. Bảo mật, phân quyền và kiểm soát luôn được đặt làm mặc định."],
              [<IconUsers size={24} />, "violet", "Phục vụ nghiệp vụ thật", "Sản phẩm bám sát quy trình văn phòng — từ mẫu biên bản đến cách giao việc và theo dõi."],
            ].map(([ic, cls, h, p], i) => (
              <Reveal key={i} className="card" delay={i * 80}>
                <div className={`ic ${cls as string}`}>{ic as React.ReactNode}</div>
                <h3>{h as string}</h3>
                <p>{p as string}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHead center eyebrow="Cách chúng tôi đồng hành" title="Triển khai theo từng bước, sát thực tế đơn vị" />
          <div className="steps">
            {[
              ["Khảo sát nghiệp vụ", "Tìm hiểu quy trình họp, mẫu biên bản và yêu cầu bảo mật của đơn vị."],
              ["Demo trên tình huống thật", "Trình diễn phiên âm, tóm tắt và sinh biên bản trên dữ liệu của bạn."],
              ["Triển khai & đào tạo", "Cấu hình, đưa vào môi trường phù hợp và hướng dẫn người dùng sử dụng."],
            ].map(([h, p], i) => (
              <Reveal key={i} className="step" delay={i * 70}>
                <div className="num">{String(i + 1).padStart(2, "0")}</div>
                <h3>{h}</h3>
                <p>{p}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
